import { render, staticRenderFns } from "./SsoAuthForm.vue?vue&type=template&id=0a310da9&scoped=true"
import script from "./SsoAuthForm.vue?vue&type=script&lang=js"
export * from "./SsoAuthForm.vue?vue&type=script&lang=js"
import style0 from "./SsoAuthForm.vue?vue&type=style&index=0&id=0a310da9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a310da9",
  null
  
)

export default component.exports